import {HttpHeaders} from '@angular/common/http';
import {AceLogger} from '@logging/ace-logger';

export class BaseService {

  public static readonly ERRORS_PREFIX = 'errors';

  protected readonly DATA_PREFIX = 'data';
  protected readonly METADATA_KEY = 'response_metadata';
  protected readonly RECORD_COUNT_KEY = 'record_count';
  protected readonly FIELD_AGGREGATES_KEY = 'field_aggregates';
  protected readonly ERRORS_PREFIX = BaseService.ERRORS_PREFIX;

  private readonly GATEWAY_URL_PATH_PREFIX = '/api';
  private readonly CONFIG_URL_PATH_PREFIX = '/config';

  private readonly _headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  constructor() { }

  protected getGateway(): string {
    return this.GATEWAY_URL_PATH_PREFIX;
  }

  protected getConfigUrl(): string {
    return this.CONFIG_URL_PATH_PREFIX;
  }

  protected getHeaders(): HttpHeaders {
    return this._headers;
  }
}
